module.exports = __webpack_public_path__ + "img/icon-linkedin.2773d68c.svg";